import { Navigate } from 'react-router-dom';

export const CLOUD_EVALS_ROOT = '/cloud-evals';
export const LEGACY_CLOUD_EVALS_PATH = '/view_web_eval';

export const CLOUD_EVAL_ROUTE_PATTERNS = [
  CLOUD_EVALS_ROOT,
  `${CLOUD_EVALS_ROOT}/:organizationId`,
  `${CLOUD_EVALS_ROOT}/:organizationId/:clientId`,
  `${CLOUD_EVALS_ROOT}/:organizationId/:clientId/:evaluationId`,
];

export function cloudEvalPath({ organizationId, clientId, evaluationId } = {}) {
  const segments = [organizationId, clientId, evaluationId]
    .filter((identifier) => identifier !== undefined && identifier !== null)
    .map((identifier) => encodeURIComponent(identifier));

  return [CLOUD_EVALS_ROOT, ...segments].join('/');
}

export function LegacyCloudEvalRedirect() {
  return <Navigate replace to={CLOUD_EVALS_ROOT} />;
}
